import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner1 from '../../assets/banner1.png'

import { Container, Title, Content, Table } from './styles'

export function CinemaBanner() {
 const title = 'Cinema'
 const subtitle = 'Alterar Banner'

 const fields = useMemo(
  () => [
   {
    id: 'Banner',
    page: String,
    imagem: String,
    title: String,
    status: Number
   }
  ],
  []
 )

 const {
  bannersCinema,
  setBannersCinema,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(bannersCinema.length / limit)

 const loadBannersCinema = useCallback(async () => {
  try {
   const response = await api.get('banners-cinema')

   setBannersCinema(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os banners')
  }
 }, [setBannersCinema])

 useEffect(() => {
  loadBannersCinema()
 }, [loadBannersCinema])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadBannersCinema}
     fields={fields}
     name="banners-cinema"
     title="Banner"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadBannersCinema}
     id={id}
     name="banners-cinema"
     title="Banner"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadBannersCinema}
     id={id}
     name="banners-cinema"
     folder="bannersCinema"
     title="Banner"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <Title>Gerenciador de banners</Title>
    {bannersCinema.length <= 0 ? (
     <>Nenhum banner cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Página</th>
         <th>Imagem</th>
         <th>Título</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {bannersCinema &&
         bannersCinema.slice(offset, offset + limit).map(banner => (
          <tr key={banner.id}>
           <td>{banner.id}</td>
           <td>{banner.page}</td>
           <td>
            <div>
             {banner.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/bannersCinema/${banner.file}`}
               alt={banner.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{banner.title}</td>
           <td>
            {banner.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações do banner</Title>
    <Content>
     <div>
      <img src={banner1} alt="Banner principal" />
      <h3>Banner Principal</h3>
      <p>Formato: 1920 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
